import React from "react";
import { Layout } from "../../layouts/Layout";

const CancellationRefundPolicy = () => {
  return (
    <Layout title="Cancellation & Refund Policy">
      <div className="container pt-120 pb-100">
        <div className="blog-details-content">
          <h2 className="title">Cancellation & Refund Policy</h2>
          <p>
            At Kadle Global Pvt Ltd, we take pride in supplying high-quality,
            food-grade products such as wood-pressed edible oils, grains,
            sugarcane, and fresh produce.
          </p>
          <p>
            Our products are naturally sourced, perishable, and
            quality-sensitive, and are often custom-packed immediately upon
            order confirmation.
          </p>
          <ol>
            <li>
              <h5>Policy Overview</h5>
              <p>Once an order is placed — whether through:</p>
              <ul>
                <li>
                  Our official website{" "}
                  <span className="mx-2 text-lowercase">
                    <a
                      href="https://kadleglobal.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://kadleglobal.com
                    </a>
                  </span>
                </li>
                <li>Any third-party marketplace or retail outlet</li>
                <li>A direct wholesale or institutional order</li>
              </ul>
              <p>
                No cancellations, returns, or refunds will be accepted under any
                circumstances.
              </p>
              <p>
                This includes cases of buyer's remorse, change of preference, or
                taste-based dissatisfaction.
              </p>
              <p>
                All replacement decisions rest solely with the Company's
                management, and its verdict shall be final and binding.
              </p>
            </li>
            <li>
              <h5>Liability Limitation</h5>
              <p>
                The Company is not liable for any loss, damage, or indirect
                consequence arising from product use, storage, or consumption.
              </p>
              <p>
                Customers are responsible for ensuring proper handling and
                storage post-delivery.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </Layout>
  );
};

export default CancellationRefundPolicy;
